import { Component, HostListener, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { App } from '../../app';

@Component({
    selector: 'app-shipping-and-return',
    standalone: true,
    templateUrl: './shipping-and-return.html',
    imports: [FormsModule],
    styleUrl: 'shipping-and-return.scss'
})
export class ShippingAndReturn implements OnInit {
    @HostListener('window:scroll', [])
    onWindowScroll() {
        this.app.isScrolled = window.scrollY < 99999;
        this.app.hideTopStrip = window.scrollY < 99999;
    }

    constructor(private app: App) {
    }

    ngOnInit() {
        this.app.isScrolled = true;
        this.app.hideTopStrip = true;

        const items = document.querySelectorAll(".list-group-item");
        items.forEach(item => {
            item.addEventListener("click", () => {
                items.forEach(i => i.classList.remove("active-category"));
                item.classList.add("active-category");
            });
        });
    }
}
